/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L9Inputs */

const en_mk_sec_pg_l9 = /** @type {(inputs: Mk_Sec_Pg_L9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data stored inside Indonesia`)
};

const id_mk_sec_pg_l9 = /** @type {(inputs: Mk_Sec_Pg_L9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data disimpan di dalam wilayah Indonesia`)
};

/**
* | output |
* | --- |
* | "Data stored inside Indonesia" |
*
* @param {Mk_Sec_Pg_L9Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l9 = /** @type {((inputs?: Mk_Sec_Pg_L9Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L9Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l9(inputs)
	return en_mk_sec_pg_l9(inputs)
});